import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { SearchField } from '../../../components/ui';
import useProfileSx from '../hooks/useProfileSx';
import ProfileOrgFilter from './ProfileOrgFilter';

export default function ProfileTableFilters({
  search,
  onSearchChange,
  organisationFilter,
  onOrganisationChange,
  showOrgFilter = false,
}) {
  const { tableFilters } = useProfileSx();

  return (
    <Box data-testid="profile-table-filters" sx={tableFilters.root}>
      <SearchField
        placeholder="Search profiles..."
        value={search}
        onChange={(event) => onSearchChange?.(event.target.value)}
        size="sm"
        icon={<SearchIcon sx={{ fontSize: 18 }} />}
        sx={tableFilters.search}
      />

      {showOrgFilter ? (
        <ProfileOrgFilter
          inline
          value={organisationFilter}
          onChange={onOrganisationChange}
          sx={tableFilters.orgFilter}
        />
      ) : null}
    </Box>
  );
}

ProfileTableFilters.propTypes = {
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  organisationFilter: PropTypes.object,
  onOrganisationChange: PropTypes.func,
  showOrgFilter: PropTypes.bool,
};
